"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_BASE_URL = void 0;
exports.CONTENT_BASE_URL = 'https://s7d9.scene7.com/is/content/LifeWayChristianResources';
